import $ from 'jquery';

export const setDimmed = dimmed => {
    const html = $('html');
    dimmed ?
        !isDimmed() && html.addClass('dimmed none-scroll') :
        isDimmed() && html.removeClass('dimmed none-scroll');
};

export const isDimmed = () => $('html').hasClass('dimmed');

export const gameListNav = () => {
    var $listPar = $('.content__allgame__nav');
    var $list = $('.content__allgame__nav ul');
    var $listBtn = $('.device ul li a');
    var size = $list.children().outerWidth();
    var len =  $list.children().length;
    var cnt = 0;

    $list.css('width', size*len);

    $listBtn.click(function(e) {
        cnt = 0;
        $list.stop().animate({'left': -(cnt*size)+'px'}, 'normal');
        $('.next').removeClass('off');
        $('.prev').addClass('off');
    });

    $('.next').click(function(e){
        e.preventDefault();

        cnt++;
        $('.prev').removeClass('off');
        $list.stop().animate({'left': -(size*cnt)+'px'}, 'normal');
        if ((($list.outerWidth() - $listPar.outerWidth()) - 100) <= ((size * cnt))) {
            $(this).addClass('off');
            return false;
        }
    });

    $('.prev').click(function(e){
        e.preventDefault();

        if (cnt == 0) {
            return false;
        }
        cnt--;
        $('.next').removeClass('off');
        $list.stop().animate({'left': -(cnt*size)+'px'}, 'normal');
        if (cnt == 0) $(this).addClass('off');
    });
};

export const footerNotice = () => {
    var refreshIntervalId = null;

    if ($('.footer-notice__list__item').length <= 1) {
        return false;
    }

    if (refreshIntervalId) {
        clearInterval(refreshIntervalId);
    }

    rolling();

    $('.footer-notice__list').hover(function () {
        clearInterval(refreshIntervalId);
    }, function () {
        clearInterval(refreshIntervalId);
        rolling();
    });

    $('.footer-notice__list li').css('position', 'relative');

    function rolling() {
        refreshIntervalId = setInterval(function () {
            var rolling = $('.footer-notice__list li');

            rolling.stop().animate({
                'top': -rolling.height()
            }, {
                duration: 1000,
                easing: 'easeInOutQuint',
                complete: function () {
                    rolling.stop().css('top', '0px');
                    $('.footer-notice__list').append(
                        rolling.eq(0)
                    );
                }
            })
        }, 5000);
    }
}

export const cpNotice = () => {
    var refreshIntervalId = window.refreshIntervalId;
    var btnPrev = $('.notice__btn--prev');
    var btnNext = $('.notice__btn--next');
    var noticeUl = $('.notice__list ul');
    
    if ($('.notice__list li').length <= 1) {
        return false;
    }
    if (refreshIntervalId) {
        clearInterval(refreshIntervalId);
    }
    
    rolling(0);
    
    var count = 0;
    $('.notice__list li').css('position', 'relative');
    
    btnNext.on('mouseenter', function (e) {
        if (refreshIntervalId) {
            clearInterval(refreshIntervalId);
        }
    });
    btnNext.on('mouseleave', function (e) {
        if (refreshIntervalId) {
            clearInterval(refreshIntervalId);
        }
        rolling(0);
    });
    
    btnPrev.on('mouseenter', function (e) {
        if (refreshIntervalId) {
            clearInterval(refreshIntervalId);
        }
    });
    btnPrev.on('mouseleave', function (e) {
        if (refreshIntervalId) {
            clearInterval(refreshIntervalId);
        }
        rolling(0);
    });
    
    noticeUl.on('mouseenter', function (e) {
        if (refreshIntervalId) {
            clearInterval(refreshIntervalId);
        }
    });
    noticeUl.on('mouseleave', function (e) {
        if (refreshIntervalId) {
            clearInterval(refreshIntervalId);
        }
        rolling(0);
    });
    
    btnPrev.on('click', function (e) {
        e.preventDefault();
        animation(0);
    });
    btnNext.on('click', function (e) {
        e.preventDefault();
        animation(1);
    });
    
    function animation(c) {
        var rolling = $('.notice__list li');
        var h = rolling.height();
        if (c == 0) {
            h = h;
        } else {
            h = -h;
        }
        rolling.stop().animate({
            'top': h
        }, {
            duration: 500,
            easing: 'easeInOutQuint',
            complete: function () {
                rolling.stop().css('top', '0px');
                if (c == 0) {
                    var child = $('.notice__list ul li').last();
                    $('.notice__list ul').prepend(child);
                } else {
                    var child = $('.notice__list ul li').first();
                    $('.notice__list ul').append(child);
                }
            }
        });
    }
    
    function rolling() {
        refreshIntervalId = window.refreshIntervalId = setInterval(function () {
            animation(0);
        }, 5000);
    }
};

export const UIAPP = {
    slider: {
        name : 'banner slider',
        description: 'up platform banner slider design handling',
        version : '1.0.0',
        settings : {
            _el: $(".slider"),
            _screen: $(".slider__screen"),
            _paging: $(".slider__dot"),
            _sliderItemWidth: 125,
            _slider_itemPer: 2,
            _slider_speed: 200,
            _slider_timer: 4,
            _slider_autoPlay: true,
            _slider_randomPlay: true,
            _slider_dot: true,
            _addClass: "is-active",
            _sliderControler: $(".slider__control")
        },
        init : function (options) {
            $.extend(true, this.settings, options);
            var self = this;
            if(options._el.index() != -1){
                this.bindings(options);
            }
        },
        bindings : function (options) {
            var $count = options._slider_timer;
            if($(options._screen).find('li').length <= 1){
                //$(options._sliderControler).css('display','none')
                return false;
            }
            var $count = options._slider_timer;
            if(options._slider_randomPlay == true){
                var $curSlide = Math.floor((Math.random() * options._screen.find('ul').length) + 0);
            }else{
                var $curSlide = 0;
            }
            var $sliderTarget= options._screen.find('ul');
            var $oldSlide = -1;
            var $tempSlide = -1;
            var $totalSlide = options._screen.find('ul').length - 1;
            var $speed = options._slider_speed;
            var $slideWidth = options._slideWidth;
            if(options._slider_autoPlay){
                var $countdown = setInterval(startSlider, 1000);
            }
            function init(){
                moveDot($curSlide);
                options._screen.find('ul').css("left", $slideWidth * - 1+"px" );
                options._screen.find('ul').eq($curSlide).css("left",0 + "px");
                $oldSlide = $curSlide;
            }
            for(var i=0; i<$totalSlide + 1; i++){ //
                options._paging.find('ul').append("<li></li>");
                options._paging.find('li').eq( i ).text(i + 1);
            }
            if(!options._slider_dot){
                options._paging.append("<div class='slider__num'></div>");
                options._paging.find('.slider__num').append("<div class='current__num'></div>");
                options._paging.find('.slider__num').append("<div class='end__num'></div>");
                $('.end__num').text($totalSlide+1)
                $('.current__num').text($curSlide+1)
                options._paging.find('ul').css("display","none");
            }else{
                $('.slider__num').css("display","none");
                options._paging.find('ul').css("display","block");
            }
            function moveDot(num){
                options._paging.find('li').eq(num).addClass(options._addClass);
                options._paging.find('li').eq(num).siblings().removeClass("is-active");
            }
            function setSlider(num,pos){
                $curSlide = num;
                if(pos == "left"){
                    options._screen.find('ul').eq(num).css("left",$slideWidth+"px");
                    options._screen.find('ul').eq($oldSlide).css("left",0+"px");
                    options._screen.find('ul').eq(num).stop().animate({'left':0},options._slider_speed,"easeInOutQuart", function() {});
                    options._screen.find('ul').eq($oldSlide).stop().animate({'left':$slideWidth * -1},options._slider_speed,"easeInOutQuart", function() {});
                }
                if(pos == "right"){
                    options._screen.find('ul').eq(num).css("left",$slideWidth * - 1+"px");
                    options._screen.find('ul').eq($oldSlide).css("left",0+"px");
                    options._screen.find('ul').eq(num).stop().animate({'left':0},options._slider_speed,"easeInOutQuart", function() {});
                    $tempSlide = $oldSlide;
                    options._screen.find('ul').eq($oldSlide).stop().animate({'left':$slideWidth},options._slider_speed,"easeInOutQuart", function() {
                        options._screen.find('ul').eq($tempSlide).css("left",$slideWidth * - 1+"px");
                    });
                }
                $oldSlide = num;
            }
            options._paging.find('li').each(function() {
                $(this).click(function(e) {
                    if($curSlide != $(this).index()){
                        $curSlide = $(this).index();
                        moveDot($curSlide);
                        setSlider($curSlide, "left");
                    }
                });
            });
            options._sliderControler.find(".button--next").click(function(){
                moveNextSlide();
            });
            options._sliderControler.find(".button--prev").click(function(){
                movePrevSlide();
            });
            function moveNextSlide(){
                if($curSlide < $totalSlide){
                    $curSlide++
                }else{
                    $curSlide = 0;
                }
                moveDot($curSlide);
                setSlider($curSlide, "left");
                $('.end__num').text($totalSlide+1)
                $('.current__num').text($curSlide+1)
            }
            function movePrevSlide(){
                if($curSlide > 0){
                    $curSlide--
                }else{
                    $curSlide = $totalSlide;
                }
                moveDot($curSlide);
                setSlider($curSlide, "right");
                $('.end__num').text($totalSlide+1)
                $('.current__num').text($curSlide+1)
            }
            function startSlider(){
                $count--;
                if ($count == 0) {
                    $count = options._slider_timer;
                    moveNextSlide();
                }
            }
            function stopSlider() {
                clearInterval($countdown);
            }
            if(options._slider_autoPlay){
                options._screen.on('mouseover',function(){
                    stopSlider();
                });
                options._sliderControler.on('mouseover',function(){
                    stopSlider();
                });
                options._paging.on('mouseover',function(){
                    stopSlider();
                });
                options._screen.on('mouseleave',function(){
                    $countdown = setInterval(startSlider, 1000);
                });
                options._sliderControler.on('mouseleave',function(){
                    $countdown = setInterval(startSlider, 1000);
                });
                options._paging.on('mouseleave',function(){
                    $countdown = setInterval(startSlider, 1000);
                });
            }
            init();
        }
    },
    cardSlider: {
        cardSliderClear: null,
        name: 'banner slider',
        description: 'up platform banner slider design handling',
        version: '1.0.0',
        settings: {},
        init: function (options) {
            var _this = this;
            $.extend(true, this.settings, options);
            var self = this;
            var slider = $('[slider=true]');
            var button = null;
            var paging = null;
            var rolling = null;
            var animate = null;
            if (_this.cardSliderClear) {
                for (var i = 0; i < _this.cardSliderClear.length; i++) {
                    clearInterval(_this.cardSliderClear[i]);
                }
            }
            _this.cardSliderClear = [];
            for (var i = 0; i < slider.length; i++) {
                if (slider.eq(i).attr('button') != undefined) {
                    button = slider.eq(i).attr('button') == 'true' ? true : null;
                }
                if (slider.eq(i).attr('paging') != undefined) {
                    paging = slider.eq(i).attr('paging') == 'true' ? true : null;
                }
                if (slider.eq(i).attr('rolling') != undefined) {
                    rolling = slider.eq(i).attr('rolling') == 'true' ? true : null;
                    _this.cardSliderClear.push(null);
                }
                if (slider.eq(i).attr('animate') != undefined) {
                    animate = slider.eq(i).attr('animate') == 'true' ? true : null;
                }
                this.bindings({
                    _el: slider.eq(i),
                    _auto: rolling,
                    _delay: slider.eq(i).attr('delay') != undefined ? Number(slider.eq(i).attr('delay')) : null,
                    _paging: paging,
                    _button: button,
                    _index: i,
                    _animate: animate
                });
            }
        },
        bindings: function (options) {
            var slider = $(options._el);
            var item = slider.find('.card__slide-item');
            var count = 0;
            var prev = 0;
            var next = 0;
            var aniClear = null;
            var autoClear = null;
            var _this = this;
            slider.find('.card__paging').remove();
            slider.find('.card__prev , .card__next').remove();
            if (options._paging) {
                slider.append('<div class="card__paging"></div>');
            }
            if (options._button) {
                slider.append('<button type="button" class="card__prev"></button><button type="button" class="card__next"></button>');
            }
            var paging = slider.find('.card__paging');
            var btnPrev = slider.find('.card__prev');
            var btnNext = slider.find('.card__next');
            
            for (var i = 0; i < item.length; i++) {
                if (i) {
                    item.eq(i).css({'left': 20});
                    if (options._paging) {
                        paging.append('<button type="button" class="card__paging__control"></button>');
                    }
                } else {
                    item.eq(i).css({'opacity': 1});
                    if (options._paging) {
                        paging.append('<button type="button" class="card__paging__control is-active"></button>');
                    }
                }
            }
            var pagingButton = paging.find('button');
            item.eq(0).css('left', 0).css('z-index', 1);
            slider.add(pagingButton).add(btnPrev).add(btnNext).unbind('mouseover');
            slider.add(pagingButton).add(btnPrev).add(btnNext).unbind('mouseleave');
            pagingButton.add(btnPrev).add(btnNext).unbind('click');
            
            btnNext.on('click', function () {
                nextMove(null);
            });
            btnPrev.on('click', function () {
                prevMove(null);
            });
            slider.add(pagingButton).add(btnPrev).add(btnNext).on('mouseover', function () {
                if (_this.cardSliderClear[options._index]) {
                    clearInterval(_this.cardSliderClear[options._index]);
                }
            });
            slider.on('mouseleave', function (e) {
                e.preventDefault();
                if (_this.cardSliderClear[options._index]) {
                    clearInterval(_this.cardSliderClear[options._index]);
                }
                auto();
            });
            pagingButton.on('click', function () {
                if (count == $(this).index()) {
                    return false;
                }
                if (count > $(this).index()) {
                    prevMove($(this).index());
                } else {
                    nextMove($(this).index());
                }
            });
            auto();
            
            function auto() {
                if (!options._auto) {
                    return false;
                }
                if (_this.cardSliderClear[options._index]) {
                    clearInterval(_this.cardSliderClear[options._index]);
                }
                _this.cardSliderClear[options._index] = setInterval(function () {
                    nextMove(null);
                }, options._delay);
            }
            
            function prevMove(c) {
                if (aniClear) {
                    return false;
                }
                
                
                prev = count;
                if (c == undefined) {
                    count -= 1;
                } else {
                    count = c;
                }
                
                if (count < 0) {
                    count = item.length - 1;
                }
                pagingButton.removeClass('is-active');
                pagingButton.eq(count).addClass('is-active');
                item.removeClass('is-active');
                item.eq(count).addClass('is-active');
                animate(20, 0);
            }
            
            function nextMove(c) {
                
                if (aniClear) {
                    return false;
                }
                prev = count;
                if (c == undefined) {
                    count += 1;
                } else {
                    count = c;
                }
                if (count > item.length - 1) {
                    count = 0;
                }
                
                pagingButton.removeClass('is-active');
                pagingButton.eq(count).addClass('is-active');
                item.removeClass('is-active');
                item.eq(count).addClass('is-active');
                animate(-20, 0);
                
            }
            
            function animate(p, n) {
                aniClear = this;
                var prevLeft = 0;
                item.eq(prev).css('z-index', 0);
                if (p == -20) {
                    item.eq(count).css('z-index', 1).css('display', 'block').css('left', 20);
                } else {
                    item.eq(count).css('z-index', 1).css('display', 'block').css('left', -20);
                }
                
                pagingButton.removeClass('is-active');
                pagingButton.eq(count).addClass('is-active');
                
                if (!options._animate) {
                    item.eq(prev).stop().css({
                        'opacity': 0,
                        'left': p,
                        'display': 'none'
                    });
                    item.eq(count).stop().css({
                        'opacity': 1,
                        'left': n,
                        'display': 'block'
                    });
                    aniClear = null;
                    return false;
                }
                item.eq(prev).stop().animate({
                    'left': p,
                    'opacity': 0
                }, {
                    duration: 700,
                    easing: 'easeInOutQuad',
                    complete: function () {
                        $(this).css('display', 'none');
                    }
                });
                item.eq(count).stop().animate({
                    'left': n,
                    'opacity': 1
                }, {
                    duration: 400,
                    easing: 'easeInOutQuad',
                    complete: function () {
                        aniClear = null;
                    }
                });
                
            }
        }
    },
    popover: {
        hoverClass: function () {
            var $self = $(this),
                className = $self.attr('js-hover');
            $self.toggleClass(className);
        },
        clickAlert: function () {
            var $anchor = $(this),
                layer = $(this).attr('href') || $(this).data('target'),
                layer = layer.replace('@', '#'),
                $layer = $(layer),
                $dialogs = $('.dialog');
            $layer
            .dialog({
                dimmed: true,
                scroll: false
            })
            .show()
            .one('click', '.js-alert-x', function () {
                $layer.hide();
                if (!$dialogs.is(':visible')) {
                    $layer.dialog({
                        dimmed: false,
                        scroll: true
                    });
                }
            });
            // UIAPP.drawSelect.init({
            //     $el: $('.js-formbox--base-c.js-formbox--shape-b'),
            //     _name: 'formbox--base-c',
            //     _shape: 'formbox--shape-b'
            // });
            return false;
        },
        clickLayer: function () {
            var $anchor = $(this),
                layer = $(this).attr('href'),
                layer = layer.replace('@', '#'),
                $layer = $(layer);
            $layer
            .dialog({
                dimmed: true,
                scroll: false
            })
            .show()
            .one('click', '.js-layer-x', function () {
                $layer
                .dialog({
                    dimmed: false,
                    scroll: true
                })
                .hide();
            });
            return false;
        },
        clickLayerPopover: function () {
            var $anchor = $(this),
                $target = $(this.hash),
                $layer = $('.layer'),
                offset = $anchor.offset(),
                scrollTop = $(window).scrollTop(),
                opts = $anchor.attr('js-layer-popover') || '{ "left": 0, "top": 0 }',
                opts2json = JSON.parse(opts),
                top = (offset.top - scrollTop) + opts2json.top,
                left = offset.left + opts2json.left;
            if ($target.length === 0) {
                var popoverId = $anchor.attr('popover-id');
                $target = $(popoverId);
            }
            if ($.prevPopover) {
                $.prevPopover.hide();
            }
            $.prevPopover = $target;
            $target
            .show()
            .css({position: 'fixed', top: top, left: left})
            .one('click', '.js-popover-x', function () {
                $target.hide();
            });
            $(document).on('click.popover', function (e) {
                if (!$target.is(e.target) && $target.has(e.target).length === 0) {
                    $target.hide();
                    $(document).off('click.popover');
                }
            });
            
            $(document).on('scroll', function () {
                $target.hide();
            });

            $('.feed__card.js-scrollbar').on('scroll', function () {
                $target.hide();
            });
            
            return false;
        },
        clickPopover: function () {
            var $anchor = $(this),
                $target = $(this.hash),
                offset = $anchor.offset(),
                scrollTop = $(window).scrollTop(),
                opts = $anchor.attr('js-popover') || '{ "left": 0, "top": 0 }',
                opts2json = JSON.parse(opts),
                top = (offset.top - scrollTop) + opts2json.top,
                left = offset.left + opts2json.left;
            if ($.prevPopover) {
                $.prevPopover.hide();
            }
            $.prevPopover = $target;
            $target
            .show()
            .css({position: 'fixed', top: top, left: left})
            .one('click', '.js-popover-x', function () {
                $target.hide();
            });
            $(document).on('click.popover', function (e) {
                if (!$target.is(e.target) && $target.has(e.target).length === 0) {
                    $target.hide();
                    $(document).off('click.popover');
                }
            });
            $(document).on('scroll', function () {
                $target.hide();
            });
            
            $('#dialog--detail').on('mousewheel', function () {
                $target.hide();
            });
            
            $($target).on('click', function () {
                $target.hide();
            });
            
            return false;
        },
        hoverPopover: function () {
            var $self = $(this),
                offset = $self.offset(),
                id = $self.attr('js-hover-popover'),
                data = $self.data();
            $(id).toggle();
            if (data.position) {
                $(id).css({
                    position: 'fixed',
                    top: offset.top + data.position.top,
                    left: offset.left + data.position.left
                });
            }
        }
    },
    viewer: {
        name: 'feed images slide',
        description: 'up platform images slider design handling',
        version: '1.0.0',
        settings: {},
        add: function (data, index) {
            $('#media , #imageload').remove();
            $('body').removeClass('disabled-scroll');
            var mediadata = new Array(data)[0];
            this.data = [];
            
            for (var i = 0; i < mediadata.length; i++) {
                if (mediadata[i].mediaType != 'MUSIC') {
                    this.data.push(mediadata[i]);
                }
            }
            this.pageing = 5;
            this.html = '';
            this.html += '<div id="media" class="media">';
            this.html += '<div id="views" class="media__view">';
            this.html += '<div id="resize" class="media__view__resize"></div>';
            this.html += '<div class="spinner spinner--base-a" id="spinner-media"></div>';
            if (this.data.length > 1) {
                this.html += '<button type="button" class="media__view-prev" id=""><i class="icon icon--prev"></i></button>';
                this.html += '<button type="button" class="media__view-next" id=""><i class="icon icon--next"></i></button>';
            }
            this.html += '</div>';
            this.html += '<div class="media__thumbnail">';
            this.html += '<ul class="media__thumbnail__items">';
            this.html += '</ul>';
            if (this.data.length > this.pageing) {
                this.html += '<button type="button" class="media__thumbnail-prev" style="display:none"><i class="icon icon--prev"></i></button>';
                this.html += '<button type="button" class="media__thumbnail-next" style="display:none"><i class="icon icon--next"></i></button>';
            }
            this.html += '</div>';
            this.html += '<div class="media__paging">';
            this.html += '<strong class="current">1</strong>  /   <span class="total">4</span>';
            this.html += '</div>';
            this.html += '<button title="close" class="btn media__close" type="button">';
            this.html += '<i class="icon icon--close"></i>';
            this.html += '</button>';
            this.html += '<div class="media__modal"></div>';
            this.html += '</div>';
            this.html += '<div id="imageload" style="position:absolute;top:-1000px;left:-1000px;width:100px;height:100px;overflow:hidden;"></div>';
            if ($('#media').length == 0) {
                $('body').append(this.html);
            }
            
            $('body').removeClass('disabled-scroll').addClass('disabled-scroll');
            
            this.mediaLayer = $('#media');
            this.mediaLayer.css('display', 'block');
            new scrollUI({
                obj: $('#resize')
            });
            
            this.thum = this.mediaLayer.find('.media__thumbnail');
            this.thumItems = this.thum.find('.media__thumbnail__items');
            this.thumItem = this.thum.find('.media__thumbnail__items__item');
            this.thumImage = this.thum.find('.media__thumbnail__items__item img');
            this.ThumSliderPrev = this.thum.find('.media__thumbnail-prev');
            this.ThumSliderNext = this.thum.find('.media__thumbnail-next');
            this.view = this.mediaLayer.find('#views');
            this.viewSliderPrev = this.view.find('.media__view-prev');
            this.viewSliderNext = this.view.find('.media__view-next');
            this.resize = this.mediaLayer.find('#resize');
            this.scrollContent = this.mediaLayer.find('#scroll-content');
            this.imageLoad = $('#imageload');
            this.pagingobj = this.mediaLayer.find('.media__paging');
            this.thumloadingCount = 0;
            this.viewCounter = 0;
            this.thumActiveIndex = 0;
            if (index) {
                this.thumActiveIndex = index;
            }
            this.viewCounter = this.thumActiveIndex;
            this.viewActive = 0;
            this.thumCounter = 0;
            this.pagingCounter = this.mediaLayer.find();
            this.viewScrolActive = null;
            var self = this;
            var thumImageLength = this.data.length;
            this.init();
            this.mediaLayer.find('.media__close').on('click', function (event) {
                event.stopPropagation();
                self.mediaLayer.remove();
                $('#imageload').remove();
                $('body').removeClass('disabled-scroll');
            });
            this.mediaLayer.find('.scrollable').on('click', function () {
                self.mediaLayer.remove();
                $('#imageload').remove();
                $('body').removeClass('disabled-scroll');
            });
            this.mediaLayer.find('.scrollable-arrow-top , .scrollable-face , .scrollable-arrow-bottom ').on('click', function (e) {
                e.stopPropagation();
            });
        },
        init: function () {
            var self = this;
            var t = 0;
            var thumbUrl;
            var previewUrl;
            var mediaUrl;
            var mediaType;
            var videoicon = '';
            var data;
            var html = '';
            var activeClassName = '';
            var thumItem;
            this.thumItems.html('');
            var save;
            var spinner = '';
            var mediaWidth;
            var mediaHeight;
            for (var i = 0; i < this.data.length; i++) {
                data = this.data[i];
                thumbUrl = data.thumbUrl || data.previewUrl;
                mediaUrl = data.mediaUrl;
                mediaType = data.mediaType;
                mediaType = mediaType.toLowerCase();
                mediaWidth = data.imgWidth;
                mediaHeight = data.imgHeight;
                if (mediaType == 'image') {
                    videoicon = '';
                } else {
                    videoicon = '<i class="icon icon--video"></i>';
                }
                if (i == this.thumActiveIndex) {
                    activeClassName = 'is-active';
                } else {
                    activeClassName = '';
                }
                if (data.imgWidth && data.imgHeight) {
                    html = '<li class="media__thumbnail__items__item"><div class="spinner spinner--base-a"></div><a href="' + mediaUrl + '" class="media-item media-' + mediaType + ' ' + activeClassName + '" media-index="' + i + '"><img src="' + thumbUrl + '" id="item-' + i + '"  media-width="' + data.imgWidth + '" media-height="' + data.imgHeight + '" />' + videoicon + '</a></li>';
                } else {
                    html = '<li class="media__thumbnail__items__item"><div class="spinner spinner--base-a"></div><a href="' + mediaUrl + '" class="media-item media-' + mediaType + ' ' + activeClassName + '" media-index="' + i + '"><img src="' + thumbUrl + '" id="item-' + i + '"  />' + videoicon + '</a></li>';
                }
                this.thumItems.append(html);
                thumItem = this.thumItems.find('.media-item img').eq(i);
                
                thumItem.on('load', function () {
                    self.ThumbnailImageSize($(this));
                });
                thumItem.on('error', function () {
                    $(this).css('display', 'none');
                });
                if (i >= 5) {
                    thumItem.parent().parent().css('left', 20 + (t * 110)).css('opacity', 0);
                    t++;
                    if (t > 4) {
                        t = 0;
                    }
                } else {
                    thumItem.parent().parent().css({
                        'left': i * 110
                    }).addClass('current-page');
                }
            }
            this.thumImage = this.thum.find('.media__thumbnail__items__item img');
            this.thumItem = this.thum.find('.media__thumbnail__items__item');
            
            this.pagingobj.find('.total').html(
                this.data.length
            );
            this.pagingobj.find('.current').html(1);
            /*
             if(this.thumItem.length < 5){
             this.pagingobj.find('.current').html(1)
             this.pagingobj.find('.total').html(1)
             }
             */
            this.viewSlider();
        },
        ThumbnailImageSize: function (image) {
            var self = this;
            if (image.width() == 0 || image.height() == 0) {
                image.on('load', function () {
                    self.ThumbnailImageSize(this);
                });
            }
            image.parent().parent().find('.spinner').remove();
            image.attr('org-width', image.width()).attr('org-height', image.height());
            image.css('display', 'block');
            if (image.width() > image.height()) {
                image.css({
                    'width': 100,
                    'height': 'auto'
                });
                if (image.height() < 100) {
                    image.css('top', (100 - image.height()) / 2);
                }
            } else {
                image.css({
                    'width': 'auto',
                    'height': 100
                });
                if (image.width() < 100) {
                    image.css('left', (100 - image.width()) / 2);
                }
            }
            this.thumloadingCount += 1;
            if (this.thumloadingCount >= this.data.length) {
                this.ThumSliderPrev.css('display', 'block');
                this.ThumSliderNext.css('display', 'block');
                if (this.thumItem.length > 5) {
                    this.ThumbnailSlider();
                }
            }
        },
        ThumbnailSlider: function () {
            var movePosi = this.thumImage.eq(this.pageing).position().left;
            var self = this;
            this.delayTime = 700;
            self.thumCounter = Math.floor((this.thumActiveIndex) / 5) * 5;
            self.ThumbnailSetPosition({
                loopS: 0,
                loopE: self.thumItem.length - 1,
                targetS: self.thumCounter,
                targetE: (self.thumCounter + 4),
                dir: 'right',
                init: false
            });
            
            function prevEvent() {
                if (($.now() - self.delayTime) < 600) {
                    return false;
                }
                self.thumCounter -= 5;
                if (self.thumCounter < 0) {
                    self.thumCounter = Math.floor((self.thumItem.length - 1) / 5) * 5;
                    self.ThumbnailSetPosition({
                        loopS: 0,
                        loopE: self.thumItem.length - 1,
                        targetS: self.thumCounter,
                        targetE: (self.thumCounter + 4),
                        dir: 'left-reset',
                        init: false
                    });
                    
                } else {
                    self.ThumbnailSetPosition({
                        loopS: 0,
                        loopE: self.thumItem.length - 1,
                        targetS: self.thumCounter,
                        targetE: (self.thumCounter + 4),
                        dir: 'left',
                        init: false
                    });
                }
                delayTime = $.now();
            }
            
            function nextEvent() {
                if (($.now() - self.delayTime) < 600) {
                    return false;
                }
                self.thumCounter += 5;
                if (self.thumCounter > self.thumItem.length - 1) {
                    self.thumCounter = 0;
                    self.ThumbnailSetPosition({
                        loopS: 0,
                        loopE: self.thumItem.length - 1,
                        targetS: self.thumCounter,
                        targetE: (self.thumCounter + 4),
                        dir: 'right-reset',
                        init: false
                    });
                } else {
                    self.ThumbnailSetPosition({
                        loopS: 0,
                        loopE: self.thumItem.length - 1,
                        targetS: self.thumCounter,
                        targetE: (self.thumCounter + 4),
                        dir: 'right',
                        init: false
                    });
                }
                delayTime = $.now();
            }
            
            this.ThumSliderPrev.on('click', function (event) {
                event.stopPropagation();
                prevEvent();
                
            });
            this.ThumSliderNext.on('click', function (event) {
                event.stopPropagation();
                nextEvent();
            });
        },
        ThumbnailSetPosition: function (arr) {
            var self = this;
            var start = arr.loopS;
            var end = arr.loopE;
            var c = 0;
            var setLeft = 0;
            var a = 0;
            var r = 0;
            var l = 6;
            var z = 0;
            var time = 0;
            var leftInit = 0;
            var rightInit = 0;
            if (arr.loopS > arr.loopE) {
                end = arr.loopS;
                start = arr.loopE;
            }
            for (var i = start; i <= end; i++) {
                if (arr.targetS <= c && arr.targetE >= c) {
                    
                    time = (500 + (a * 110));
                    
                    if (arr.dir == 'left') {
                        time = 500 + (500 - (a * 110));
                    }
                    if (arr.dir == 'left-reset') {
                        time = (500 + (a * 110));
                    }
                    if (arr.dir == 'right-reset') {
                        time = 500 + (500 - (a * 110));
                    }
                    self.thumItem.eq(c).css('display', 'block').addClass('current-page');
                    sliderAnimation(
                        self.thumItem.eq(c),
                        a * 110,
                        time,
                        c,
                        1
                    );
                    a++;
                } else {
                    l--;
                    if (arr.targetS > c) {
                        time = 400 + (500 - ((l * 110)));
                        self.thumItem.eq(c).removeClass('current-page');
                        sliderAnimation(self.thumItem.eq(c), ((z * 110) - 20), time, c, 0);
                    }
                    if (arr.targetE < c) {
                        time = 0;
                        time = 500 + ((l * 110));
                        if (arr.dir == 'left') {
                            time = ((l * 110));
                        }
                        self.thumItem.eq(c).removeClass('current-page');
                        sliderAnimation(self.thumItem.eq(c), ((r * 110) + 20), time, c, 0);
                    }
                    r++;
                    if (r > 4) {
                        r = 0;
                    }
                    if (l < 2) {
                        l = 6;
                    }
                    z++;
                    if (z > 4) {
                        z = 0;
                    }
                }
                c++;
            }
            
            function sliderAnimation(obj, left, time, c, alpha) {
                var opt = 0;
                obj.stop().animate(
                    {
                        'left': left,
                        'opacity': alpha
                    }, {
                        duration: time,
                        easing: 'easeInOutQuint',
                        complete: function () {
                            if (alpha == 0) {
                                $(this).css('display', 'none');
                            }
                        }
                    });
            }
        },
        insertResizeItem: function (n, func) {
            var html = '';
            var data = this.data[n];
            var thumbUrl = data.thumbUrl;
            var mediaUrl = data.mediaUrl;
            var mediaType = this.getMediaType(mediaUrl);
            
            var orgWidth = this.thumItem.eq(n).find('img').attr('media-width');
            var orgHeight = this.thumItem.eq(n).find('img').attr('media-height');

            orgWidth = orgWidth === undefined ? this.thumItem.eq(n).find('img')[0].naturalWidth : orgWidth;
            orgHeight = orgHeight === undefined ? this.thumItem.eq(n).find('img')[0].naturalHeight : orgHeight;

            if (mediaType == 'image') {
                var videoicon = '';
                if (!!~window.navigator.userAgent.search(/(Unity|ZFBrowser|EmbeddedBrowser)/ig)) {
                    html = '<a href="javascript:;" onclick="javascript:event.stopPropagation();" class="media-item media-' + mediaType + '" media-type="image" media-index="' + n + '" target="_blank"><img id="item-resize-' + n + '" src="' + mediaUrl + '" org-width="' + (orgWidth == undefined ? 676 : orgWidth) + '" org-height="' + (orgHeight == undefined ? 360 : orgHeight) + '" id="item-' + n + '" />' + videoicon + '</a>';
                }
                else {
                    html = '<a href="' + mediaUrl + '" class="media-item media-' + mediaType + '" media-type="image" media-index="' + n + '" target="_blank"><img id="item-resize-' + n + '" src="' + mediaUrl + '" org-width="' + (orgWidth == undefined ? 676 : orgWidth) + '" org-height="' + (orgHeight == undefined ? 360 : orgHeight) + '" id="item-' + n + '" />' + videoicon + '</a>';
                }
            } else {
                html = '<div class="media-item" media-index="' + n + '"><iframe width="100%" height="100%" src="' + mediaUrl + '" frameborder="0" allowfullscreen id="item-resize-' + n + '" org-width="' + 640 + '" org-height="' + 480 + '" minetype="video"></iframe></div>';
            }
            this.imageLoad.html(html);
        },
        viewSlider: function () {
            this.viewSliderActive = this;
            var self = this;
            var pagingNext = 0;
            var pagingPrev = 0;
            
            setImage(null, this.thumActiveIndex, null);
            var delay = $.now();
            var now = 0;
            var clear = null;
            //        self.viewCounter=0;
            this.thumItem.find('.media-item').on('click', function (event) {
                
                if (clear) {
                    clearTimeout(clear);
                }
                var prevIndex = 0;
                event.stopPropagation();
                prevIndex = self.viewCounter;
                self.viewCounter = parseInt($(this).attr('media-index'));
                if (prevIndex == self.viewCounter) {
                    return false;
                }
                self.thumItem.find('.media-item').removeClass('is-active');
                self.thumItem.eq(self.viewCounter).find('.media-item ').addClass('is-active');
                
                setRemove('thumbnail', self.viewCounter, prevIndex);
                clear = setTimeout(function () {
                    setImage('thumbnail', self.viewCounter);
                }, 100);
                self.pagingobj.find('.current').html(
                    self.viewCounter + 1
                );
                return false;
            });
            $(document).on('keydown', function (e) {
                e = e || window.event;
                if (e.keyCode == 37) {
                    prevEvent();
                } else if (e.keyCode == 39) {
                    nextEvent();
                }
            });
            
            function prevEvent() {
                if (($.now() - self.delayTime) < 600) {
                    return false;
                }
                if (clear) {
                    clearTimeout(clear);
                }
                if (self.thumItem.length <= 1) {
                    return false;
                }
                self.viewCounter--;
                if (self.viewCounter < 0) {
                    self.viewCounter = (self.thumItem.length - 1);
                }
                setRemove('left', self.viewCounter);
                clear = setTimeout(function () {
                    setImage('left', self.viewCounter);
                }, 100);
                pagingPrev = Math.floor((self.viewCounter) / 5) * 5;
                self.ThumbnailSetPosition({
                    loopS: 0,
                    loopE: self.thumItem.length - 1,
                    targetS: pagingPrev,
                    targetE: (pagingPrev + 4),
                    dir: 'left',
                    init: false
                });
                self.pagingobj.find('.current').html(
                    self.viewCounter + 1
                );
                self.thumItem.find('.media-item').removeClass('is-active');
                self.thumItem.eq(self.viewCounter).find('.media-item').addClass('is-active');
                self.delayTime = $.now();
            }
            
            function nextEvent() {
                if (($.now() - self.delayTime) < 600) {
                    return false;
                }
                if (clear) {
                    clearTimeout(clear);
                }
                if (self.thumItem.length <= 1) {
                    return false;
                }
                self.viewCounter++;
                if (self.viewCounter > self.thumItem.length - 1) {
                    self.viewCounter = 0;
                }
                setRemove('right', self.viewCounter);
                clear = setTimeout(function () {
                    setImage('right', self.viewCounter);
                }, 100);
                pagingNext = Math.floor((self.viewCounter) / 5) * 5;
                self.ThumbnailSetPosition({
                    loopS: 0,
                    loopE: self.thumItem.length - 1,
                    targetS: pagingNext,
                    targetE: (pagingNext + 4),
                    dir: 'right',
                    init: false
                });
                self.pagingobj.find('.current').html(
                    self.viewCounter + 1
                );
                self.thumItem.find('.media-item').removeClass('is-active');
                self.thumItem.eq(self.viewCounter).find('.media-item ').addClass('is-active');
                self.delayTime = $.now();
            }
            
            this.viewSliderPrev.on('click', function (event) {
                event.stopPropagation();
                prevEvent();
            });
            this.viewSliderNext.on('click', function (event) {
                event.stopPropagation();
                nextEvent();
            });
            
            function imgonload(dir, n) {
                $('#spinner-media').css('display', 'block');
                if ($('#item-resize-' + n).attr('minetype') && $('#item-resize-' + n).attr('minetype') == 'video') {
                    $('#spinner-media').css('display', 'none');
                    setPosi(dir, n);
                } else {
                    $('#item-resize-' + n).on('load', function () {
                        $('#spinner-media').css('display', 'none');
                        if ($(this).width() == 0 || $(this).height() == 0) {
                            imgonload(dir, n);
                        }
                        else {
                            if (!$(this).attr('org-width') || !$(this).attr('org-height')) {
                                $(this).attr('org-width', $(this).width()).attr('org-height', $(this).height());
                            }
                            setPosi(dir, n);
                        }
                    });
                }
            }
            
            function setImage(dir, n) {
                if ($('#item-resize-' + (n)).length == 0) {
                    self.insertResizeItem(n);
                    imgonload(dir, n);
                }
            }
            
            function setRemove(dir, n, p) {
                var removeItem;
                removeItem = $('#item-resize-' + (p));
                if (clear) {
                    removeItem.parent().stop().remove();
                }
                if (dir == 'right') {
                    removeItem = $('#item-resize-' + (n - 1));
                    
                    if (self.viewCounter == 0) {
                        removeItem = $('#item-resize-' + (self.thumItem.length - 1));
                    }
                }
                if (dir == 'left') {
                    removeItem = $('#item-resize-' + (self.viewCounter + 1));
                    if (self.viewCounter == (self.thumItem.length - 1)) {
                        removeItem = $('#item-resize-' + (0));
                    }
                }
                if (dir) {
                    if (removeItem.length != 0) {
                        if (removeItem.attr('minetype')) {
                            removeItem.parent().remove();
                        } else {
                            removeItem.parent().stop().animate(
                                {
                                    'opacity': 0
                                }, {
                                    duration: 100,
                                    easing: 'easeInOutQuint',
                                    complete: function () {
                                        $(this).remove();
                                        clear = null;
                                    }
                                });
                        }
                    }
                }
            }
            
            function setPosi(dir, n) {
                var removeItem;
                
                if (dir) {
                    self.viewsResize(this, n);
                    $(this).remove();
                }
                if (!dir) {
                    self.viewsResize(null, n);
                }
            }
        },
        viewsResize: function (anicheck, n) {
            var self = this;
            var current = $('#item-resize-' + (n));
            self.resizeWidth = parseInt(current.attr('org-width'));
            self.resizeHeight = parseInt(current.attr('org-height'));
            self.resize.html(self.imageLoad.html());
            
            var resize = $('#resize');
            var small = 1.10;
            var ratio = this.resizeWidth > this.resizeHeight ? this.resizeWidth / this.resizeHeight : this.resizeHeight / this.resizeWidth;
            self.imageLoad.html('');
            current = $('#item-resize-' + (n));
            var resizeImage = $('#item-resize-' + (n));
            viewChage(anicheck);
            var sefWidth = 0;
            var setHeight = 0;
            var setLeft = 0;
            
            function viewChage(a) {
                var body = new getOffsetBody();
                if (2500 < self.resizeHeight) {
                    if (self.resizeHeight > self.resizeWidth) {
                        scrollImage(a);
                    } else {
                        resizingImage(a);
                    }
                } else {
                    resizingImage(a);
                }
            }
            
            function scrollImage(a) {
                var resizeWidth = self.resizeWidth;
                var resizeHeight = self.resizeHeight;
                var body = new getOffsetBody();
                var bodyHeight = body.height - 228;
                var bodyWidth = body.width - 200;
                var setWidth;
                var setHeight;
                var setLeft;
                var setTop;
                resize.removeClass('media__view__resize').addClass('media__view__scroll');
                if (bodyWidth < resizeWidth) {
                    setWidth = body.width - 160;
                    setLeft = 80;
                } else {
                    setWidth = self.resizeWidth - 8;
                    setLeft = (body.width - self.resizeWidth) / 2;
                }
                animation({
                    scroll: true,
                    animate: a != null ? true : null,
                    width: setWidth,
                    height: resizeHeight,
                    top: 60,
                    left: setLeft
                });
            }
            
            function resizingImage(a) {
                resize.removeClass('media__view__scroll').addClass('media__view__resize');
                var resizeWidth = self.resizeWidth;
                var resizeHeight = self.resizeHeight;
                var body = new getOffsetBody();
                var bodyHeight = body.height - 228;
                var bodyWidth = body.width - 200;
                if (resizeWidth > resizeHeight) {
                    resizeWidth = bodyWidth;
                    resizeHeight = resizeWidth / ratio;
                }
                else {
                    resizeHeight = bodyHeight;
                    resizeWidth = resizeHeight / ratio;
                }
                if (resizeHeight > bodyHeight) {
                    resizeHeight = bodyHeight;
                    resizeWidth = resizeHeight * ratio;
                }
                if (resizeWidth > bodyWidth) {
                    resizeWidth = bodyWidth;
                    resizeHeight = resizeWidth * ratio;
                }
                if (self.resizeWidth < bodyWidth) {
                    resizeWidth = self.resizeWidth;
                    resizeHeight = self.resizeWidth > self.resizeHeight ? self.resizeWidth / ratio : resizeWidth * ratio;
                    if (resizeHeight > bodyHeight) {
                        resizeHeight = bodyHeight;
                        resizeWidth = self.resizeWidth > self.resizeHeight ? resizeHeight * ratio : resizeHeight / ratio;
                    }
                }
                if (self.resizeHeight < bodyHeight) {
                    resizeHeight = self.resizeHeight;
                    resizeWidth = self.resizeWidth > self.resizeHeight ? resizeHeight * ratio : resizeHeight / ratio;
                    if (resizeWidth > bodyWidth) {
                        resizeWidth = bodyWidth;
                        resizeHeight = self.resizeWidth > self.resizeHeight ? resizeWidth / ratio : resizeWidth * ratio;
                    }
                }
                body = new getOffsetBody();
                bodyHeight = body.height;
                bodyWidth = body.width;
                
                animation({
                    scroll: null,
                    animate: a != null ? true : null,
                    width: resizeWidth,
                    height: resizeHeight,
                    top: (((bodyHeight - 151) - resizeHeight) / 2),
                    left: (bodyWidth - resizeWidth) / 2
                });
            }
            
            function animation(arr) {
                var body = new getOffsetBody();
                var resizeWidth = arr.width;
                var resizeHeight = arr.height;
                var bodyHeight = body.height;
                var bodyWidth = body.width;
                var imgWidth;
                var imgHeight;
                var imgTop;
                var imgLeft;
                var resizeTop;
                var resizeLeft;
                var barWidth = 0;
                resizeTop = arr.top;
                resizeLeft = arr.left;
                var cusHeight = resizeHeight;
                var cusWidth = resizeWidth;
                if (arr.scroll) {
                    cusHeight = body.height - 240;
                    barWidth = 20;
                }
                imgWidth = resizeWidth;
                imgHeight = arr.scroll ? 'auto' : resizeHeight;
                
                if (arr.animate == null) {
                    
                    resize.parent().css({
                        width: cusWidth,
                        height: cusHeight,
                        left: resizeLeft,
                        top: resizeTop,
                        opacity: 1
                    });
                    resize.css({
                        width: cusWidth + barWidth,
                        height: cusHeight,
                        left: 0,
                        top: 0
                    });
                    resizeImage.stop().css({
                        width: imgWidth,
                        height: imgHeight,
                        left: 0,
                        top: 0,
                        opacity: 1
                    });
                    
                } else {
                    resize.parent().css({
                        width: cusWidth,
                        height: cusHeight,
                        left: resizeLeft,
                        top: resizeTop,
                        opacity: 1
                    });
                    resize.css({
                        width: cusWidth + barWidth,
                        height: cusHeight,
                        left: 0,
                        top: 0,
                        opacity: 0
                    });
                    resizeImage.stop().css({
                        width: imgWidth,
                        height: imgHeight,
                        left: 0,
                        top: 0,
                        opacity: 0
                    });
                    resize.parent().stop().animate(
                        {
                            opacity: 1
                        }, {
                            duration: 100,
                            easing: 'linear'
                        });
                    resize.stop().animate(
                        {
                            opacity: 1
                        }, {
                            duration: 100,
                            easing: 'linear'
                        });
                    resizeImage.stop().animate(
                        {
                            opacity: 1
                        }, {
                            duration: 100,
                            easing: 'linear'
                        });
                }
            }
            
            $(window).on('resize', function () {
                viewChage(null);
            });
        },
        getMaxWidth: function () {
            var image = this.thumImage.length;
            var widthSize = 0;
            for (var i = 0; i < image; i++) {
                if (
                    Number($(this.thumImage).eq(i).attr('media-width')) > image
                ) {
                    widthSize = Number($(this.thumImage).eq(i).attr('media-width'));
                }
            }
            return widthSize;
        },
        getMediaType: function (str) {
            var arr = ['.jpeg', '.gif', '.png', '.bmp', '.jpg'];
            var getType = null;
            for (var i = 0; i < arr.length; i++) {
                str = str.toLowerCase();
                if (str.indexOf(arr[i]) > 0) {
                    getType = arr[i];
                    break;
                }
            }
            if (getType) {
                getType = 'image';
            } else {
                getType = 'movie';
            }
            return getType;
        }
    },
    cropper: function (el, opt) {
        var container = el.find('.img-container');
        
        if (!container) {
            return false;
        }
        var Cropper = window.Cropper;
        
        var image = container.find('img')[0];
        var actions = el.find('#actions')[0];
        
        var options = {
            
            preview: '.img-preview',
            build: function () {
            },
            built: function () {
            },
            cropstart: function () {
            },
            cropmove: function () {
            },
            cropend: function () {
            },
            crop: function () {
            },
            zoom: function () {
            },
            autoCropArea: 1,
            viewMode: opt.viewMode,
            aspectRatio: opt.aspectRatio
            
        };
        var cropper = new Cropper(image, options);
        cropper.setAspectRatio(opt.aspectRatio);
        
        // Buttons
        if (!document.createElement('canvas').getContext) {
            $('button[data-method="getCroppedCanvas"]').prop('disabled', true);
        }
        
        if (typeof document.createElement('cropper').style.transition === 'undefined') {
            $('button[data-method="rotate"]').prop('disabled', true);
            $('button[data-method="scale"]').prop('disabled', true);
        }
        
        
        // Methods
        actions.querySelector('.docs-buttons').onclick = function (event) {
            var e = event || window.event;
            var target = e.target || e.srcElement;
            var result;
            var input;
            var data;
            
            if (!cropper) {
                return;
            }
            while (target !== this) {
                if (target.getAttribute('data-method')) {
                    break;
                }
                target = target.parentNode;
            }
            if (target === this || target.disabled || target.className.indexOf('disabled') > -1) {
                return;
            }
            data = {
                method: target.getAttribute('data-method'),
                target: target.getAttribute('data-target'),
                option: target.getAttribute('data-option'),
                secondOption: target.getAttribute('data-second-option')
            };
            
            if (data.method) {
                if (typeof data.target !== 'undefined') {
                    input = document.querySelector(data.target);
                    
                    if (!target.hasAttribute('data-option') && data.target && input) {
                        try {
                            data.option = JSON.parse(input.value);
                        } catch (e) {
                            $log.debug(e.message);
                        }
                    }
                }
                
                if (data.method === 'getCroppedCanvas') {
                    data.option = JSON.parse(data.option);
                }
                
                result = cropper[data.method](data.option, data.secondOption);
                
                switch (data.method) {
                    
                    case 'getCroppedCanvas':
                        if (result) {
                            $log.debug(result.toDataURL('image/jpeg'));
                        }
                        break;
                    case 'destroy':
                        cropper = null;
                        break;
                    default:
                        break;
                }
                
                if (typeof result === 'object' && result !== cropper && input) {
                    try {
                        input.value = JSON.stringify(result);
                    } catch (e) {
                        $log.debug(e.message);
                    }
                }
                
            }
        };
        return cropper;
    },
    headerFixed: {
        name: 'headerFixed',
        description: 'up platform header scroll fixed',
        version: '1.0.0',
        settings: {
            _el: $('.header--main'),
            _listener: 'window',
            _scrollTop: 10,
            _addClass: 'header-fixed'
        },
        init: function (options) {
            $.extend(true, this.settings, options);
            var self = this;
            this.bindings(options);
        },
        bindings: function (options) {
            $(window).on('scroll', function () {
                var naverHeader = 0;
                if ($('.global_wrap').length != 0) {
                    naverHeader = $('.global_wrap').height();
                }
                if ($(this).scrollTop() > (options._scrollTop + naverHeader)) {

                    $(options._el).addClass(options._addClass);

                } else {
                    $(options._el).removeClass(options._addClass);
                }

                if ($('body').is('.is-sticky-header')) {
                    $(options._el).addClass('is-client-promote');
                } else {
                    $(options._el).removeClass('is-client-promote');
                }
            });
        }
    },
    searchBar3: {
        name: 'rate-it',
        description: 'up platform tab design handling',
        version: '1.0.0',
        settings: {},
        init: function () {
            var self = this;
            return this.bindings();
        },
        bindings: function (options) {
            var self = this;
            this.bar = $('#search--bar');
            this.btn = $('#search--btn');
            this.glass = this.btn.find('i');
            
            this.searchInput = this.bar.find('.form--control');
            this.searchBtn = this.bar.find('.search--box__btn');
            this.searchClose = this.bar.find('.search--box__btn-close');
            
            if (this.btn.attr('event') != undefined) {
                return false;
            }
            $('input, textarea').placeholder();
            this.btn.attr('event', 'active');
            this.glass.append('<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16px" height="17px" viewBox="0 0 16 17" enable-background="new 0 0 16 17" xml:space="preserve"><circle fill="none" stroke="#505050" stroke-miterlimit="10" cx="7.276" cy="7.275" r="6.774"/><line fill="none" stroke="#505050" stroke-miterlimit="10" x1="11.594" y1="12.127" x2="15.502" y2="16.602"/></svg>');
            this.glass.addClass('icon--svg');
            this.searchClose.find('.icon').append('<svg class="close" xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="20px" height="20px"><line fill="none" stroke="#666666" stroke-miterlimit="10" x1="17.608" y1="1.565" x2="1.823" y2="17.35"/><line fill="none" stroke="#666666" stroke-miterlimit="10" x1="1.823" y1="1.564" x2="17.607" y2="17.351"/></svg>');
            
            this.searchClose.find('.icon').addClass('icon--svg');
            
            this.nav = $('.page--header__nav__item');
            this.navItem = this.nav.find('.page--header__nav__item li');
            
            this.bar.css('opacity', 0).css('display', 'none');
            this.bar.css('width', 52);
            this.searchClose.find('i').css('transform', 'scale(0.3)');
            
            var delay = null;
            this.searchClose.on('click', function () {
                if (self.btn.attr('class').indexOf('is-active') >= 0) {
                    if (delay) {clearTimeout(delay);}
                    self.closeAnimation(10);
                    delay = setTimeout(
                        function () {
                            self.barAnimation({
                                obj: self.bar,
                                width: 0,
                                active: null,
                                opacity: 0,
                                time: 300
                            });
                        }, 300
                    );
                }
            });
            this.btn.on('click', function () {
                if ($(this).attr('class').indexOf('is-active') < 0) {
                    if (delay) {
                        clearTimeout(delay);
                    }
                    self.bar.css('display', 'block');
                    self.btnAnimation(10);
                    self.closeAnimation(0);
                    delay = setTimeout(
                        function () {
                            self.barAnimation({
                                obj: self.bar,
                                width: 276,
                                active: this,
                                opacity: 1,
                                time: 400
                            });
                            
                        }, 400
                    );
                    
                }
                return false;
            });
        },
        barAnimation: function (arr) {
            var self = this;
            arr.obj.stop().animate(
                {
                    opacity: arr.opacity,
                    width: arr.width
                    
                }, {
                    duration: arr.time,
                    easing: 'easeInOutCubic',
                    complete: function () {
                        if (arr.active) {
                            self.btn.addClass('is-active');
                        } else {
                            self.btn.removeClass('is-active');
                            self.bar.css('display', 'none');
                            self.btnAnimation(0);
                        }
                    }
                });
        },
        closeAnimation: function (n) {
            var stop = 0;
            this.searchClose.stop().animate(
                {
                    whyNotToUseANonExistingProperty: n
                }, {
                    duration: 300,
                    easing: 'easeInOutCubic',
                    complete: function () {
                    
                    },
                    step: function (now, fx) {
                        $(this).find('i').css('transform', 'scale(' + (1 - (now / 10)) + ')');
                    }
                });
        },
        formAnimation: function (arr) {
            var self = this;
            arr.obj.stop().animate(
                {
                    left: arr.left,
                    opacity: arr.opacity
                    
                }, {
                    duration: arr.time,
                    easing: 'easeInOutCubic',
                    complete: function () {
                    
                    }
                });
        },
        btnAnimation: function (n) {
            var stop = 0;
            this.btn.stop().animate(
                {
                    whyNotToUseANonExistingProperty: n
                }, {
                    duration: 300,
                    easing: 'easeInOutCubic',
                    complete: function () {
                    
                    },
                    step: function (now, fx) {
                        $(this).find('i').css('transform', 'scale(' + (1 - (now / 10)) + ')');
                    }
                });
        }
    },
    drawCheckbox: {
        name: 'drawCheckbox',
        settings: {
            $el: {},
            _name: 'formstyle'
        },
        init: function (options) {
            var opts = $.extend(true, this.settings, options);
            this.markup(opts);
            $.fn[opts._name] = this.setState.call(this);
        },
        getInputStateClases: function (input, namespace) {
            var wrapClassList = [];
            wrapClassList.push(namespace);
            wrapClassList.push(input.type ? namespace + '--' + input.type : '');
            wrapClassList.push(input.checked ? namespace + '--checked' : '');
            wrapClassList.push(input.disabled ? namespace + '--disabled' : '');
            return wrapClassList;
        },
        setState: function () {
            var self = this;
            return function (options) {
                var $inputs = $(this),
                    wrapClassList = [];
                if (typeof options === 'string') {
                    var state = options;
                    $inputs.each(function (i, input) {
                        var wrapClassList = [];
                        if (state === 'enable') {
                            input.disabled = false;
                        }
                        if (state === 'disable') {
                            input.disabled = true;
                        }
                        if (state === 'check') {
                            input.checked = true;
                        }
                        if (state === 'uncheck') {
                            input.checked = false;
                        }
                        wrapClassList = self.getInputStateClases(input, 'formstyle');
                        $(input)
                        .parent()
                        .attr('class', '')
                        .addClass(wrapClassList.join(' '));
                    });
                }
            };
        },
        markup: function (options) {
            var self = this,
                $inputs = options.$el;
            $inputs
            .each(function (i, input) {
                var isStyle = $(input).parent().is('.formstyle');
                if (isStyle) {
                    return;
                }
                var iconClassName = 'formstyle__icon',
                    wrapClassList = self.getInputStateClases(input, 'formstyle');
                $(input)
                .wrap('<span></span>')
                .parent()
                .addClass(wrapClassList.join(' '))
                .append('<i class="' + iconClassName + '"></i>');
            })
            .on('focusin', function () {
                var $input = $(this);
                $input
                .parent()
                .addClass('formstyle--focused');
            })
            .on('focusout', function () {
                $inputs
                .parent()
                .removeClass('formstyle--focused');
            });
            setTimeout(function () {
                $inputs.on('change', function () {
                    var $input = $(this);
                    if (this.type === 'checkbox') {
                        $input
                        .parent()
                        .toggleClass('formstyle--checked');
                    }
                    if (this.type === 'radio') {
                        $inputs
                        .filter('[type=radio]')
                        .filter('[name=' + $input[0].name + ']')
                        .parent()
                        .removeClass('formstyle--checked');
                        $input
                        .parent()
                        .addClass('formstyle--checked');
                    }
                });
            }, 200);
        }
    },
    dropdown: {
        name: 'dropdown',
        settings: {
            $el: $('.dropdown-toggle')
        },
        init: function (options) {
            var settings = $.extend(true, this.settings, options);
        
            //		this.bindings(settings);
        
            if (!settings.$el.parent().parent().hasClass('game')) {
                this.bindings(settings);
            }
        },
        bindings: function (settings) {
            var $el = settings.$el;
        
            $el.off('click.dropdown');
            $(document).off('click.dropdown');
        
            $el.on('click.dropdown', function (e) {
                e.preventDefault();
                var $self = $(this),
                    $dropdown = $self.parents('.dropdown');
                $('.dropdown').not($dropdown).removeClass('open');
                $dropdown.toggleClass('open');
            });
        
            $(document).on('click.dropdown', function (e) {
                var $dropdown = $el.parents('.dropdown'),
                    $except = $dropdown.find('[data-except]'),
                    isExcept = $except.data('except'),
                    isToggle = $dropdown.has(e.target).length;
                // dropdown toggle �댁쇅 �곸뿭�� �대┃ �� �レ� �딆쓬.
                if (isToggle) {
                    return;
                }
                // dropdown�� �먯떇�붿냼瑜� �F대┃ �� �レ� �딆쓬.
                if (isExcept && $except.has(e.target).length) {
                    return;
                }
                $('.dropdown').removeClass('open');
            });
        }
    }
};

function scrollUI(arr) {
    this.target = arr.obj;
    this.ran = this.randomUi(200, 2000);
    this.setup();
    this.mouseOffset;
    this.track = this.obj.find('.scrollable-track');
    this.bar = this.obj.find('.scrollable-bar');
    this.handle = this.obj.find('.scrollable-face');
    this.topBtn = this.obj.find('.scrollable-arrow-top');
    this.btmBtn = this.obj.find('.scrollable-arrow-bottom');
    this.body = this.target;
    
    this.content = arr.content;
    this.move = null;
    var self = this;
    this.scrollStopClear = null;
    this.scrollLiveClear = null;
    this.mouseMotion = null;
    
    $(document).on('mousemove', function (e) {
        self.buttonDrag(e);
    });
    $(document).on('mouseup', function () {
        self.move = null;
        self.scrollLive();
    });
    this.scrollLive();
    this.body.on('scroll', function () {
        if (self.move == null) {
            clearInterval(self.scrollLiveClear);
            self.scrollStop(function () {
                self.scrollLive();
            });
            self.scrollReset();
        }
    });
    this.handle[0].onmousedown = function (e) {
        e = e || window.event;
        e.stopPropagation();
        self.move = $(this);
        clearInterval(self.scrollLiveClear);
        self.mouseOffset = self.getPosi(self.track, this, e);
        $(this).addClass('active');
        return false;
    };
    this.handle[0].onmouseup = function () {
        $(this).removeClass('active');
    };
    this.track.on('mousedown', function (e) {
        e = e || window.event;
        var scHeight = self.getContentHeight(self.body);
        scHeight = scHeight - self.body.height();
        self.body.scrollTop(
            ((scHeight) / (self.track.height() - self.handle.height())) *
            (((new getMouse(e).Y - (self.handle.height() / 2)) + $(window).scrollTop()) - self.track.offset().top)
        );
    });
    this.topBtn.on('mousedown', function () {
        clearInterval(self.scrollLiveClear);
        var scrTop = self.scrollBtmStop(
            self.body.scrollTop() - ((self.getContentHeight(self.body) - self.body.height()) / 10)
        );
        self.body.scrollTop(scrTop);
        $(this).addClass('active');
    });
    this.btmBtn.on('mousedown', function () {
        clearInterval(self.scrollLiveClear);
        var scrTop = self.scrollBtmStop(
            self.body.scrollTop() + ((self.getContentHeight(self.body) - self.body.height()) / 10)
        );
        self.body.scrollTop(scrTop);
        $(this).addClass('active');
    });
    this.topBtn.on('mouseup', function () {
        self.scrollLive();
        $(this).removeClass('active');
    });
    this.btmBtn.on('mouseup', function () {
        self.scrollLive();
        $(this).removeClass('active');
    });
    this.bar.on('mousewheel DOMMouseScroll', function (e) {
        if (self.move) {
            return false;
        }
        var detail = 0;
        var scrTop = 0;
        var e = e.originalEvent;
        if (e.detail) {
            detail = e.detail * -40;
        } else {
            detail = e.wheelDelta;
        }
        wheel(detail);
        return false;
    });
    
    /*
     this.track.on('mousewheel DOMMouseScroll', function(e) {
     if(self.move){return false}
     wheel(e)
     });
     */
    function wheel(detail) {
        if (detail < 0) {
            clearInterval(self.scrollLiveClear);
            scrTop = self.scrollBtmStop(
                self.body.scrollTop() + ((self.getContentHeight(self.body) - self.body.height()) / 20)
            );
        } else {
            scrTop = self.scrollBtmStop(
                self.body.scrollTop() - ((self.getContentHeight(self.body) - self.body.height()) / 20)
            );
        }
        self.body.scrollTop(scrTop);
        
    }
    
    $(document).on('mouseout', function () {
        self.handle.removeClass('active');
        self.topBtn.removeClass('active');
        self.btmBtn.removeClass('active');
    });
}

scrollUI.prototype.randomUi = function (start, end) {
    return Math.floor((Math.random() * (end - start + 1)) + start);
};
scrollUI.prototype.setup = function () {
    var html = '';
    this.scrollObject = 'scrollable-' + this.ran;
    html += '<div class="scrollable" id="' + this.scrollObject + '">';
    html += '<div class="scrollable-body"></div>';
    html += '<div class="scrollable-bar">';
    html += '<button type="button" class="scrollable-arrow-top" disabled="disabled"><i class="icon icon--arrow-up"></i></button>';
    html += '<div class="scrollable-track">';
    html += '<button class="scrollable-face" type="button"></button>';
    html += '</div>';
    html += '<button type="button" class="scrollable-arrow-bottom"><i class="icon icon--arrow-down"></i></button>';
    html += '</div>';
    html += '</div>';
    this.target.after(html);
    this.obj = $('#' + this.scrollObject);
    this.body = this.obj.find('.scrollable-body');
    this.body.append(this.target);
};
scrollUI.prototype.scrollTopEnd = function (s) {
    if (s <= 0) {
        s = 0;
        this.topBtn.addClass('disabled');
        this.topBtn.attr('disabled', true);
    } else {
        this.topBtn.removeClass('disabled');
        this.topBtn.attr('disabled', false);
    }
    return new getScrollTop(s).top;
};
scrollUI.prototype.scrollBtmStop = function (s) {
    var scrollBtm = this.getContentHeight(this.body) - this.body[0].offsetHeight;
    
    if (scrollBtm <= s) {
        s = scrollBtm;
        this.btmBtn.addClass('disabled');
        this.btmBtn.attr('disabled', true);
    } else {
        this.btmBtn.removeClass('disabled');
        this.btmBtn.attr('disabled', false);
    }
    return new getScrollTop(s).top;
};
scrollUI.prototype.scrollStop = function (f) {
    if (this.scrollStopClear) {
        clearTimeout(this.scrollStopClear);
    }
    this.scrollStopClear = setTimeout(function () {
        f();
    }, 200);
};
scrollUI.prototype.scrollLive = function () {
    var self = this;
    if (this.scrollLiveClear) {
        clearInterval(this.scrollLiveClear);
    }
    this.scrollLiveClear = setInterval(function () {
        if (
            (self.body[0].offsetHeight + 10) >= self.getContentHeight(self.body) || self.body[0].offsetHeight > self.getContentHeight(self.body)
        ) {
            
            self.bar.fadeOut(200);
        } else {
            self.bar.fadeIn(200);
        }
        self.scrollReset();
        
    }, 100);
};
scrollUI.prototype.getContentHeight = function (o) {
    return o.prop('scrollHeight');
};
scrollUI.prototype.getPosi = function (sc, se, e) {
    e = e || window.event;
    return (new getMouse(e).Y - $(sc).offset().top) - $(se).position().top;
};
scrollUI.prototype.scrollReset = function () {
    this.track.css({
        top: this.topBtn.height(),
        height: this.bar.height() - (this.topBtn.height() + this.btmBtn.height())
    });
    this.buttonResize();
    this.buttonPosition();
    this.scrollBtmStop(this.body.scrollTop());
    this.scrollTopEnd(this.body.scrollTop());
};
scrollUI.prototype.mouseMovingCheck = function () {
};
scrollUI.prototype.buttonPosition = function () {
    var scHeight = this.getContentHeight(this.body);
    scHeight = scHeight - this.body.height();
    this.body.scrollTop() / (scHeight / (this.track.height() - this.handle.height()));
    this.handle.css('top', Math.ceil(this.body.scrollTop() / (scHeight / (this.track.height() - this.handle.height()))));
};
scrollUI.prototype.scrollContent = function () {
    var scHeight = this.getContentHeight(this.body);
    scHeight = scHeight - this.body.height();
    this.body.scrollTop(
        ((scHeight) / (this.track.height() - this.handle.height())) * this.handle.position().top
    );
};
scrollUI.prototype.buttonResize = function () {
    var scHeight = this.getContentHeight(this.body);
    scHeight = scHeight - this.body.height();
    var scContHeight = scHeight;
    if (scContHeight >= this.track.height()) {
        scContHeight = (this.track.height() - (this.track.height() / 10) / 1.1);
    }
    this.handle.css('height', this.track.height() - scContHeight);
};
scrollUI.prototype.buttonDrag = function (e) {
    var dragtop = 0;
    if (this.move) {
        e = e || window.event;
        dragtop = (new getMouse(e).Y - this.track.offset().top) - this.mouseOffset;
        if (dragtop < 0) {
            dragtop = 0;
        }
        else if ((dragtop + $(this.handle).height()) > this.track.height()) {
            dragtop = this.track.height() - $(this.handle).height();
        }
        $(this.handle).css('top', dragtop);
        this.scrollContent();
    }
};

function getScrollTop(s) {
    this.top = s;
}


function getOffsetBody() {
    if ($('#getOffsetBody').length == 0) {
        $('body').append('<div style="position:fixed;top:0;left:0;width:100%;height:100%;z-index:-1;" id="getOffsetBody"></div>');
    }
    this.width = $('#getOffsetBody').width();
    this.height = $('#getOffsetBody').height();
    $('#getOffsetBody').remove();
}

(function (window, document, $) {
    
    var isOperaMini = Object.prototype.toString.call(window.operamini) == '[object OperaMini]';
    var isInputSupported = 'placeholder' in document.createElement('input') && !isOperaMini;
    var isTextareaSupported = 'placeholder' in document.createElement('textarea') && !isOperaMini;
    var prototype = $.fn;
    var valHooks = $.valHooks;
    var propHooks = $.propHooks;
    var hooks;
    var placeholder;
    
    if (isInputSupported && isTextareaSupported) {
        placeholder = prototype.placeholder = function () {
            return this;
        };
        placeholder.input = placeholder.textarea = true;
    } else {
        placeholder = prototype.placeholder = function () {
            var $this = this;
            $this
            .filter((isInputSupported ? 'textarea' : ':input') + '[placeholder]')
            .not('.placeholder')
            .bind({
                'focus.placeholder': clearPlaceholder,
                'blur.placeholder': setPlaceholder
            })
            .data('placeholder-enabled', true)
            .trigger('blur.placeholder');
            return $this;
        };
        
        placeholder.input = isInputSupported;
        placeholder.textarea = isTextareaSupported;
        
        hooks = {
            'get': function (element) {
                var $element = $(element);
                
                var $passwordInput = $element.data('placeholder-password');
                if ($passwordInput) {
                    return $passwordInput[0].value;
                }
                
                return $element.data('placeholder-enabled') && $element.hasClass('placeholder') ? '' : element.value;
            },
            'set': function (element, value) {
                var $element = $(element);
                
                var $passwordInput = $element.data('placeholder-password');
                if ($passwordInput) {
                    return $passwordInput[0].value = value;
                }
                
                if (!$element.data('placeholder-enabled')) {
                    return element.value = value;
                }
                if (value == '') {
                    element.value = value;
                    if (element != safeActiveElement()) {
                        setPlaceholder.call(element);
                    }
                } else if ($element.hasClass('placeholder')) {
                    clearPlaceholder.call(element, true, value) || (element.value = value);
                } else {
                    element.value = value;
                }
                return $element;
            }
        };
        if (!isInputSupported) {
            valHooks.input = hooks;
            propHooks.value = hooks;
        }
        if (!isTextareaSupported) {
            valHooks.textarea = hooks;
            propHooks.value = hooks;
        }
        
        $(function () {
            $(document).delegate('form', 'submit.placeholder', function () {
                var $inputs = $('.placeholder', this).each(clearPlaceholder);
                setTimeout(function () {
                    $inputs.each(setPlaceholder);
                }, 10);
            });
        });
        
        $(window).bind('beforeunload.placeholder', function () {
            $('.placeholder').each(function () {
                this.value = '';
            });
        });
        
    }
    
    function args(elem) {
        var newAttrs = {};
        var rinlinejQuery = /^jQuery\d+$/;
        $.each(elem.attributes, function (i, attr) {
            if (attr.specified && !rinlinejQuery.test(attr.name)) {
                newAttrs[attr.name] = attr.value;
            }
        });
        return newAttrs;
    }
    
    function clearPlaceholder(event, value) {
        var input = this;
        var $input = $(input);
        if (input.value == $input.attr('placeholder') && $input.hasClass('placeholder')) {
            if ($input.data('placeholder-password')) {
                $input = $input.hide().next().show().attr('id', $input.removeAttr('id').data('placeholder-id'));
                if (event === true) {
                    return $input[0].value = value;
                }
                $input.focus();
            } else {
                input.value = '';
                $input.removeClass('placeholder');
                input == safeActiveElement() && input.select();
            }
        }
    }
    
    function setPlaceholder() {
        var $replacement;
        var input = this;
        var $input = $(input);
        var id = this.id;
        if (input.value == '') {
            if (input.type == 'password') {
                if (!$input.data('placeholder-textinput')) {
                    try {
                        $replacement = $input.clone().attr({'type': 'text'});
                    } catch (e) {
                        $replacement = $('<input>').attr($.extend(args(this), {'type': 'text'}));
                    }
                    $replacement
                    .removeAttr('name')
                    .data({
                        'placeholder-password': $input,
                        'placeholder-id': id
                    })
                    .bind('focus.placeholder', clearPlaceholder);
                    $input
                    .data({
                        'placeholder-textinput': $replacement,
                        'placeholder-id': id
                    })
                    .before($replacement);
                }
                $input = $input.removeAttr('id').hide().prev().attr('id', id).show();
            }
            $input.addClass('placeholder');
            $input[0].value = $input.attr('placeholder');
        } else {
            $input.removeClass('placeholder');
        }
    }
    
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {
        }
    }
    
}(this, document, jQuery));


// WEBPACK FOOTER //
// ./static/js/ui.js